import { ZfIconButton, ZfTextButton } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import { useTranslation } from 'react-i18next';
import { useClient, useDownloadClientPackage } from '../../api';
import { useWealthPlanningNavigate } from '../../hooks/useWealthPlanningNavigate';
import type { IDocumentTableData } from '../../interfaces/package';
import { wnSendTrace } from '../../utils/wn-event-utils';

export const DocumentTableActionsCell = ({ data }: ICellRendererParams<IDocumentTableData>) => {
    const { t } = useTranslation();
    const { navigate } = useWealthPlanningNavigate();

    const { data: client } = useClient();
    const downloadPackage = useDownloadClientPackage();

    const onPackageClick = () => {
        navigate(`/${client?.partnerUuid}/documents/${data!.id}`);
        wnSendTrace({
            feature: 'client-package',
            tags: {
                partnerUuid: client?.partnerUuid ?? '',
                action: 'open-client-package-modal',
                source: 'document-table',
                packageId: `${data!.id}`,
            },
        });
    };
    const onDownloadClick = () => downloadPackage.mutateAsync(data!.id);

    return data?.status === 'DRAFT' ? (
        <ZfTextButton hierarchy="primary" size="extra-small" onClick={onPackageClick}>
            {t('clientPackageActionFinalise')}
        </ZfTextButton>
    ) : (
        <>
            <ZfIconButton hierarchy="tertiary" size="extra-small" icon="download" onClick={onDownloadClick} />
            <ZfTextButton hierarchy="secondary" size="extra-small" onClick={onPackageClick}>
                {t('clientPackageActionView')}
            </ZfTextButton>
        </>
    );
};
